<template>
    <div class="field field--text" :class="fieldClasses">
        <div class="row collapse no-pad align-middle">
            <div class="columns shrink" v-if="helptext">
                <help-text :helptext="helptext"></help-text>
            </div>
            <div class="columns">
                <label v-if="label" :class="labelClasses">
                    <input type="checkbox" :checked="checked" :disabled="disabled" @change="updateValue">{{ label }}
                </label>
            </div>
        </div>
        <div class="row" v-if="hasErrors">
            <div class="columns">
                <ul class="field__errors">
                    <li v-for="error in errors">{{ error }}</li>
                </ul>
            </div>
        </div>
    </div>
</template>

<script>
    /**
     * Component Dependencies
     */
    import BaseField from './BaseField'

    /**
     * Component
     */
    export default {
        name: 'check_box',
        extends: BaseField,
        props: {
            disabled: {
                type: Boolean,
                required: false,
                default: false
            }
        },
        data () {
            return {
                checked: false
            }
        },
        methods: {
            updateValue (e) {
                let newVal = e.target.checked
                this.checked = newVal
                this.$emit('updated', newVal)
            }
        },
        created () {
            this.checked = !!this.value
        }
    }
</script>

<check-box :value="true">



// WEBPACK FOOTER //
// src/components/general/forms/CheckBox.vue